import { render, staticRenderFns } from "./SpecialReport.vue?vue&type=template&id=131456ab&"
import script from "./SpecialReport.vue?vue&type=script&lang=js&"
export * from "./SpecialReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports